import React, {Component} from 'react';
import axios from "../../../axios-cmk";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import {connect} from "react-redux";
import {Col, Container, Row, Table} from "reactstrap";
import {loadPatientsReportData} from "../../../store/actions";
import FontAwesome from 'react-fontawesome';
import '../Reports.css'

class PatientsReport extends Component {

    state = {
        patientFilter: '',
    };

    onPatientFilterChange = (event) => {
        this.setState({
            patientFilter: event.target.value
        })
    }

    render() {
        const patient_data_rows = this.props.patients_report_data.patients.filter((stat) => {
            if (this.state.patientFilter !== '') {
                if (stat.patient.label.toLowerCase().indexOf(this.state.patientFilter.toLowerCase()) >= 0) {
                    return stat
                }
            } else {
                return stat
            }
            return null
        }).map((stat, index) => {
            return (
                <tr key={stat.patient.id}>
                    <th>{index + 1}</th>
                    <td>{stat.patient.label}</td>
                    <td className="text-center dataColumn" sm={1}>{stat.plan_hours}h</td>
                    <td className="text-center dataColumn" sm={1}>{stat.visit_hours}h</td>
                    <td className="text-center dataColumn" sm={1}>{stat.canceled_paid}h</td>
                    <td className="text-center dataColumn" sm={1}>{stat.canceled_free}h</td>
                </tr>
            )
        });

        return (
            <Container fluid>
                <Row>
                    <Col>
                        <Table striped>
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Pacjent</th>
                                <th className="text-center" sm={1}>Zaplanowane</th>
                                <th className="text-center" sm={1}>Odbyte</th>
                                <th className="text-center" sm={1}>Anulacja płatna</th>
                                <th className="text-center" sm={1}>Anulacja darmowa</th>
                            </tr>
                            <tr>
                                <th></th>
                                <th>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1"><FontAwesome
                                                name='filter'/></span>
                                        </div>
                                        <input type="text" className="form-control" placeholder="Filtruj pacjentów"
                                               aria-describedby="basic-addon1" onChange={this.onPatientFilterChange}/>
                                    </div>
                                </th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {patient_data_rows}
                            </tbody>
                        </Table>
                    </Col>
                </Row>

            </Container>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadData: (period) => dispatch(loadPatientsReportData(period)),
    }
}

const mapStateToProps = state => {
    return {
        reports_period: state.reports.reports_period,
        patients_report_data: state.reports.patients_report_data
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(PatientsReport, axios));


// WEBPACK FOOTER //
// ./src/components/Reports/Patients/PatientsReport.js